import React from 'react'

// Sits beside a field's label when the record can't move on without it
const RequiredHint = () => (
  <span className="text-xs font-normal text-muted-foreground">Required</span>
)

export default RequiredHint
